<template>
  <div class='wrap'>
    <div class='query-banner'>
     <p class="title">openEuler认证</p>
     <p class="subTitle">openEuler - OECA</p>
    </div>
    <div class="contentBox">
        <div class="content">
            <div class="type-title" style="padding-top: 15px;">项目介绍</div>
            <div class="el-divider el-divider--horizontal"></div>
            <ul>
                <li>
                    <span>人才评定体系：</span>随着openEuler及其发行版本在各个行业使用量逐年增多，相关人才的评定诉求愈发强烈，故由openEuler社区联合统信软件及多家伙伴共同打造openEuler人才评定体系。openEuler人才评定体系旨在帮助企业快速培养专业的openEuler生态人才；推动相关从业人员高效获得权威资质评定；促使技术爱好者踊跃融入社区技术生态建设。
                </li>
                <li>
                    <span>建议掌握的知识：</span>能够熟练掌握OS安装、升级、常用服务配置、管理等基础使用能力；以及熟悉服务规范、服务礼仪、服务安全红线、服务文档编写等专业能力。
                </li>
                <li>
                    <span>面向对象：</span>面向openEuler操作系统的管理服务人员。
                </li>
            </ul>
            <!-- <div class="urlClass">openEuler官网: <a href="https://www.openeuler.org/zh/" target="_blank">https://www.openeuler.org/zh/</a></div> -->
            <div class="urlClass">培训材料：<a href="https://partner.huawei.com/university/webui_portal/#/zone?customizedZoneId=VxkRMyFZWD7vX1uyOfwZFpBugag" target="_blank">https://partner.huawei.com/university/webui_portal/#/zone?customizedZoneId=VxkRMyFZWD7vX1uyOfwZFpBugag</a></div>
            <div class="type-title" style="padding-top: 15px;">考生流程指引</div>
            <div class="el-divider el-divider--horizontal"></div>
            <div class="lineContentBox" style="padding-bottom:20px;">
                <div class="line"></div>
                <div class="bfClassBox">
                    <ul>
                        <li><span>1</span></li>
                        <li><span>2</span></li>
                        <li><span>3</span></li>
                        <li><span>4</span></li>
                        <div style="clear:both;"></div>
                    </ul>
                    <ul class="messageBox">
                        <li>
                            <div class="imgBox">
                                <img src="../../../assets/title1.png" style="width:100px;">
                            </div>
                            <div class="titleBf">填写报名信息</div>
                            <div class="messageBf">扫描下方二维码报名，使用手机号注册账号，填写并提交报名信息；</div>
                            <div class="imgBf">
                                <img src="../../../assets/bmxxewm.png">
                            </div>
                        </li>
                        <li>
                            <div class="imgBox">
                                <img src="../../../assets/title2.png" style="width:60px;">
                            </div>
                            <div class="titleBf">支付考试费用</div>
                            <div class="messageBf">通过转账完成考试报名费用支付，并保存费用支付截图凭证；</div>
                            <div class="imgBf">
                                <span>名称：南京统信软件技术有限公司</span><br><br>
                                <span>开户行：招商银行股份有限公司南京郁金香路支行</span><br><br>
                                <span>账号：125911905010101</span>
                            </div>
                        </li>
                        <li>
                            <div class="imgBox">
                                <img src="../../../assets/title3.png" style="width:100px;">
                            </div>
                            <div class="titleBf">考试资格审核</div>
                            <div class="messageBf">添加教务老师，提交报名缴费支付凭证并进行考试资格审核；添加老师企业微信时请备注：考试资格审核：姓名+身份证号；</div>
                            <div class="imgBf">
                                <img src="../../../assets/kszzewm.png">
                            </div>
                        </li>
                        <li>
                            <div class="imgBox">
                                <img src="../../../assets/title4.png" style="width:100px;">
                            </div>
                            <div class="titleBf">参加考试</div>
                            <div class="messageBf">通过考试资格审核的学生，即可开始学习，并等待通知考试，考试完成后，成绩合格者（60分及以上）视为认证通过，可获得证书。</div>
                           
                        </li>
                        <div style="clear:both;"></div>
                    </ul>
                </div>
            </div>
            <!-- <div class="el-divider el-divider--horizontal"></div>
            <div class="type-title" style="padding-top: 15px;">咨询方式</div>
            <div class="el-divider el-divider--horizontal"></div>
            <div class="lxr lxro">联系人：李望</div>
            <div class="lxr">联系电话：15101102081</div>
            <div class="lxr lxrl">邮箱：liwang@uniontech.com</div> -->
        </div>
    </div>
  </div>
  
</template>
<script>
export default {
  data() {
    return {
    };
  },
};
</script>
<style lang='scss' scoped>
@import "./index.scss"
</style>